import React from 'react';
import PropTypes from 'prop-types';

import { getBreakpoint } from '../../../Base/Breakpoints';
import TileController from '../../Tiles/Tile/TileController';

// import assets
import './teaserModule.scss';
import TeaserModuleView from './TeaserModuleView';


class TeaserModuleController extends React.Component {
  static renderTile(tileData) {
    return (<div className="m-teaser-module__tile" key={tileData.id}><TileController {...tileData} size={4} /></div>);
  }

  constructor(props) {
    super(props);

    this.state = {
      slidesToShow: 0,
    };

    this.reRenderTiles = this.reRenderTiles.bind(this);
  }

  componentDidMount() {
    this.setSlidesToShow();
    window.addEventListener('resize', this.reRenderTiles);
  }

  componentWillReceiveProps() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('resize', this.reRenderTiles);
    window.addEventListener('resize', this.reRenderTiles);
  }

  componentWillUnmount() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('resize', this.reRenderTiles);
  }

  setSlidesToShow() {
    const breakpoint = getBreakpoint();
    const length = this.props.articles.length;
    let slidesToShow = 0;
    switch (breakpoint) {
      case 'sm':
        slidesToShow = length > 1 ? 1 : 0;
        break;
      case 'md':
        slidesToShow = length > 2 ? 2 : 0;
        break;
      case 'lg':
        slidesToShow = length > 3 ? 3 : 0;
        break;
      case 'xl':
        slidesToShow = length > 3 ? 3 : 0;
        break;
      case 'xxl':
        slidesToShow = length > 4 ? 4 : 0;
        break;
      default:
        slidesToShow = 0;
    }
    if (this.state.slidesToShow !== slidesToShow) {
      this.setState({
        slidesToShow,
      });
    }
  }

  reRenderTiles() {
    clearTimeout(this.state.resizeId);
    this.setState({
      resizeId: setTimeout(() => {
        this.setSlidesToShow();
      }, 500),
    });
  }

  render() {
    const tiles = this.props.articles.map(articleData => TeaserModuleController.renderTile(articleData));
    return (<TeaserModuleView slidesToShow={this.state.slidesToShow} headline={this.props.headline} tiles={tiles} />);
  }
}

TeaserModuleController.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      sm: PropTypes.string,
      md: PropTypes.string,
      lg: PropTypes.string,
      xl: PropTypes.string,
      xxl: PropTypes.string,
      default: PropTypes.string,
    }),
    headline: PropTypes.string,
    subline: PropTypes.string,
  })),
  headline: PropTypes.string,
};

TeaserModuleController.defaultProps = {
  articles: [],
  headline: '',
};

export default TeaserModuleController;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/TeaserModule/TeaserModuleController.jsx